import React from "react";
import { COLORS } from "rylak-common/src/constants";
import { TurnrTableCell } from "../TurnrTableSmart.jsx";
import { interFont } from "~/app/_apps/fonts.jsx";

export function getTableHeadId(props) {
    return {
        id: "id",
        label: "ID",
        sortable: false,
        ...props,
    };
}

export function TableCellId({ id, fontSize = "12px", ...rest }) {
    return (
        <TurnrTableCell {...rest}>
            <div
                style={{
                    fontSize: fontSize,
                    color: COLORS.MID_BROWN,
                    whiteSpace: "nowrap",
                    fontFamily: interFont.style.fontFamily,
                }}
            >
                {id}
            </div>
        </TurnrTableCell>
    );
}
